import { render, staticRenderFns } from "./cascader-popup.vue?vue&type=template&id=13961122&scoped=true"
import script from "./cascader-popup.vue?vue&type=script&lang=js"
export * from "./cascader-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13961122",
  null
  
)

export default component.exports